/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Error } from '../models/Error'
import type { RequestCreateAdmin } from '../models/RequestCreateAdmin'
import type { RequestDisableAdmin } from '../models/RequestDisableAdmin'
import type { RequestUpdateAdmin } from '../models/RequestUpdateAdmin'
import type { RequestUpsertAdminUserMessage } from '../models/RequestUpsertAdminUserMessage'
import type { ResponseAdmin } from '../models/ResponseAdmin'
import type { ResponseGetAdminUserMessageList } from '../models/ResponseGetAdminUserMessageList'

import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'

export class AdminService {
  /**
   * Tworzy nowego admina
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static createAdmin({
    requestBody,
  }: {
    /**
     * Dane admina do utworzenia
     */
    requestBody: RequestCreateAdmin
  }): CancelablePromise<Error> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/admin',
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * Zwraca dane administratora
   * @returns ResponseAdmin dane admina
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getAdminById({
    adminId,
  }: {
    adminId: number
  }): CancelablePromise<ResponseAdmin | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admin/{adminId}',
      path: {
        adminId: adminId,
      },
    })
  }

  /**
   * Modyfikuje dane admina
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static modifyAdmin({
    adminId,
    requestBody,
  }: {
    adminId: number
    /**
     * Dane admina do modyfikacji
     */
    requestBody: RequestUpdateAdmin
  }): CancelablePromise<Error> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/admin/{adminId}',
      path: {
        adminId: adminId,
      },
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * Dezaktywuje konto admina
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static disableAdmin({
    adminId,
    requestBody,
  }: {
    adminId: number
    /**
     * Dane admina, który ma zastąpić blokowanego
     */
    requestBody?: RequestDisableAdmin
  }): CancelablePromise<Error> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/admin/{adminId}/disable',
      path: {
        adminId: adminId,
      },
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static createAdminUserMessage({
    requestBody,
  }: {
    requestBody?: RequestUpsertAdminUserMessage
  }): CancelablePromise<Error> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/admin/user-message',
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static updateAdminUserMessage({
    messageId,
    requestBody,
  }: {
    messageId: number
    requestBody?: RequestUpsertAdminUserMessage
  }): CancelablePromise<Error> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/admin/user-message/{messageId}',
      path: {
        messageId: messageId,
      },
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * Usuwa(a właściwie ustawia active=0) komunikat admin-użytkownik
   * @returns any komunikat admin-użytkownik usunięty
   * @throws ApiError
   */
  public static deleteAdminUserMessage({
    messageId,
  }: {
    messageId: number
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/admin/user-message/{messageId}',
      path: {
        messageId: messageId,
      },
    })
  }

  /**
   * Zwraca listę komunikatów admin-użytkownik
   * @returns ResponseGetAdminUserMessageList lista komunikatów admin-użytkownik
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getAdminUserMessageList({
    page,
    limit,
    fetchInactive,
  }: {
    /**
     * numer strony do pobrania
     */
    page: number
    /**
     * liczba elementów do pobrania
     */
    limit: number
    /**
     * filtr czy pobierać również nieaktywne(active=0) komunikaty
     */
    fetchInactive?: boolean
  }): CancelablePromise<ResponseGetAdminUserMessageList | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admin/user-messages',
      query: {
        page: page,
        limit: limit,
        fetchInactive: fetchInactive,
      },
    })
  }

  /**
   * Wyszukuje adminów zgodnych z zapytaniem
   *
   * @returns ResponseAdmin lista adminów spełniających wymagania
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static searchAdmins({
    page,
    limit,
    email,
    role,
  }: {
    /**
     * numer strony do pobrania
     */
    page: number
    /**
     * liczba elementów do pobrania
     */
    limit: number
    /**
     * ciąg znaków porównywany z emailami adminów (znajdujący %email%)
     */
    email?: string
    /**
     * wymagana role
     */
    role?: 'ADMIN' | 'ACCOUNT_MANAGER' | 'PERFORMANCE'
  }): CancelablePromise<Array<ResponseAdmin> | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admin/search',
      query: {
        email: email,
        role: role,
        page: page,
        limit: limit,
      },
    })
  }
}
